import { IUsersContext, IFilterValues } from './usersContext';

export enum UsersActionTypes {
	SET_USERS = 'SET_USERS',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	SET_ID_ROLE = 'SET_ID_CUSTOMER',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetUsers {
	type: UsersActionTypes.SET_USERS;
	payload: {
		users: IUsersContext['users'];
		typeOfModalWindow: IUsersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: UsersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IUsersContext['searchString'];
	};
}

interface ISetIDRole {
	type: UsersActionTypes.SET_ID_ROLE;
	payload: {
		IDSelectedRole: IUsersContext['IDSelectedRole'];
	};
}

interface IResetSelectedControls {
	type: UsersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: UsersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IUsersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: UsersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IUsersContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: UsersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IUsersContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: UsersActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IUsersContext['IDForDeletion'];
		typeOfModalWindow: IUsersContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: UsersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IUsersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: UsersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TUsersAction =
	| ISetUsers
	| IChangeSearchString
	| ISetIDRole
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
